import { render, staticRenderFns } from "./ViewGroup.vue?vue&type=template&id=6424e938&"
import script from "./ViewGroup.vue?vue&type=script&lang=js&"
export * from "./ViewGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports